export const MY_ACCOUNT = 'myAccount';
export const ADVICE = 'advice';
export const SEARCH = 'search';
export const SHOP = 'shop';
